<!-- src/components/comparisons/ComparisonContentCard.vue -->
<template>
  <div class="card core-card">
    <div class="card-content" :style="cardStyle">
      <div class="core-section-header">
        <div class="core-section-header-main">
          <span class="card-title core-card-title">
            {{ title }}
          </span>

          <p v-if="subtitle" class="core-card-subtitle">
            {{ subtitle }}
          </p>
        </div>

        <div class="core-section-actions core-actions core-actions--right">
          <span
            class="new badge"
            :class="badgeClass"
            :data-badge-caption="badgeCaption"
            title="RAG status"
          ></span>
        </div>
      </div>

      <div
        v-if="tiles.length"
        class="core-stat-grid core-stat-grid--3 comparison-tile-row"
      >
        <div
          v-for="(t, i) in tiles"
          :key="i"
          class="core-stat-tile core-stat-tile--compact"
          :style="tileStyle(t.rag || rag)"
        >
          <div class="core-stat-label">
            {{ t.label }}
          </div>

          <div class="core-stat-value">
            {{ t.value }}
          </div>

          <div v-if="t.hint" class="core-stat-hint">
            {{ t.hint }}
          </div>
        </div>
      </div>

      <slot />
    </div>

    <div v-if="$slots.actions" class="card-action core-actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import { RAG, ragLabel, ragBackground } from "@/scripts/sharedHelpers/auditColours";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },

  subtitle: {
    type: String,
    default: "",
  },

  // expected: RAG.GREEN | RAG.AMBER | RAG.RED | RAG.GREY
  rag: {
    type: String,
    default: RAG.GREY,
  },

  // [{ label: string, value: string, hint?: string, rag?: string }]
  tiles: {
    type: Array,
    default: () => [],
  },

  // when true, tint entire card background by rag
  tintCard: {
    type: Boolean,
    default: false,
  },
});

const badgeClass = computed(() => {
  if (props.rag === RAG.GREEN) {
    return "green";
  }

  if (props.rag === RAG.AMBER) {
    return "amber";
  }

  if (props.rag === RAG.RED) {
    return "red";
  }

  return "grey";
});

const badgeCaption = computed(() => ragLabel(props.rag));

const cardStyle = computed(() => {
  if (!props.tintCard) {
    return {};
  }

  const bg = ragBackground(props.rag);

  return bg
    ? {
        backgroundColor: bg,
      }
    : {};
});

function tileStyle(tileRag) {
  const bg = ragBackground(tileRag);

  return bg
    ? {
        backgroundColor: bg,
      }
    : {};
}
</script>

<style scoped>
.comparison-tile-row {
  margin-top: 12px;
  margin-bottom: 10px;
}
</style>
